// Core Application Logic
import { renderNavigation } from './components/Navigation';
import { renderDashboard } from './components/Dashboard';
import { renderProfileSetup } from './components/ProfileSetup';
import { Login } from './components/Login';
import { Register } from './components/Register';

export function initializeApp(appState) {
    const appContainer = document.getElementById('app');

    // Clear app container
    appContainer.innerHTML = '';

    // If using backend and not authenticated, show login
    if (appState.useBackend && !appState.isAuthenticated) {
        appContainer.appendChild(Login(appState));
        return;
    }

    // If not using backend and no user data, show profile setup
    if (!appState.useBackend && !appState.isAuthenticated) {
        appContainer.appendChild(renderProfileSetup(appState));
        return;
    }

    // Create main layout
    const mainLayout = document.createElement('div');
    mainLayout.className = 'main-layout';

    // Add navigation
    mainLayout.appendChild(renderNavigation(appState));

    // Add main content area
    const contentArea = document.createElement('main');
    contentArea.id = 'content-area';
    contentArea.className = 'container p-xl';

    mainLayout.appendChild(contentArea);
    appContainer.appendChild(mainLayout);

    // Restore last view or default to dashboard
    const lastView = localStorage.getItem('currentView') || 'dashboard';
    navigateTo(lastView, appState);
}

export function navigateTo(view, appState) {
    const contentArea = document.getElementById('content-area');
    const appContainer = document.getElementById('app');

    // Handle auth routes (no content area needed)
    if (view === 'login' || view === 'register' || view === 'setup') {
        appContainer.innerHTML = '';
        if (view === 'login') {
            appContainer.appendChild(Login(appState));
        } else if (view === 'register') {
            appContainer.appendChild(Register(appState));
        } else if (view === 'setup') {
            appContainer.appendChild(renderProfileSetup(appState));
        }
        return;
    }

    if (!contentArea) return;

    // Save current view
    localStorage.setItem('currentView', view);

    contentArea.innerHTML = '';

    switch (view) {
        case 'dashboard':
            contentArea.appendChild(renderDashboard(appState));
            break;
        case 'quests':
            import('./components/QuestList').then(module => {
                contentArea.appendChild(module.renderQuestList(appState));
            });
            break;
        case 'leaderboard':
            import('./components/Leaderboard').then(module => {
                contentArea.appendChild(module.renderLeaderboard(appState));
            });
            break;
        case 'career':
            import('./components/CareerDashboard').then(module => {
                contentArea.appendChild(module.renderCareerDashboard(appState));
            });
            break;
        case 'profile':
            import('./components/Profile').then(module => {
                contentArea.appendChild(module.renderProfile(appState));
            });
            break;
        default:
            contentArea.appendChild(renderDashboard(appState));
    }
}
